import { render, staticRenderFns } from "./CustProdIn.vue?vue&type=template&id=08d39410"
import script from "./CustProdIn.vue?vue&type=script&lang=js"
export * from "./CustProdIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports